(function () {
  const STORAGE_KEY = '__theme__wishlist';
  const drawer = document.querySelector('[data-wishlist-drawer]');
  const list = drawer?.querySelector('[data-wishlist-items]');
  const empty = drawer?.querySelector('[data-wishlist-empty]');
  const limit = Number(drawer?.dataset.limit) || 50;

  const load = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (error) {
      return [];
    }
  };

  const save = (items) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, limit)));
    render();
  };

  const escapeHtml = (value = '') => {
    const element = document.createElement('div');
    element.textContent = value;
    return element.innerHTML;
  };

  const render = () => {
    const items = load();
    document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
      count.textContent = items.length;
      count.hidden = items.length === 0;
    });

    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const active = items.some((item) => String(item.id) === String(button.dataset.productId));
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      const label = active ? button.dataset.removeLabel : button.dataset.addLabel;
      if (label) button.setAttribute('aria-label', label);
    });

    if (!list || !empty) return;
    empty.hidden = items.length !== 0;
    list.innerHTML = items
      .map(
        (item) => `
          <li class="wishlist-drawer__item">
            <a class="wishlist-drawer__image" href="${escapeHtml(item.url)}">
              ${item.image ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy" width="120" height="150">` : ''}
            </a>
            <div class="wishlist-drawer__details">
              <a href="${escapeHtml(item.url)}" class="wishlist-drawer__title">${escapeHtml(item.title)}</a>
              <span class="wishlist-drawer__price">${escapeHtml(item.price)}</span>
              <button type="button" class="button button--simple wishlist-drawer__remove" data-wishlist-remove="${escapeHtml(String(item.id))}">
                ${escapeHtml(drawer.dataset.removeText || 'Remove')}
              </button>
            </div>
          </li>`
      )
      .join('');
  };

  const open = () => {
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    document.body.classList.add('overflow-hidden');
    drawer.querySelector('[data-wishlist-close]')?.focus();
  };

  const close = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    window.setTimeout(() => {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 220);
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-wishlist-open]');
    if (openButton) {
      event.preventDefault();
      open();
      return;
    }

    if (event.target.closest('[data-wishlist-close]') || event.target.matches('[data-wishlist-overlay]')) {
      close();
      return;
    }

    const removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      save(load().filter((item) => String(item.id) !== String(removeButton.dataset.wishlistRemove)));
      return;
    }

    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (!toggle) return;
    event.preventDefault();
    event.stopPropagation();

    const id = toggle.dataset.productId;
    const items = load();
    const existingIndex = items.findIndex((item) => String(item.id) === String(id));
    if (existingIndex >= 0) {
      items.splice(existingIndex, 1);
    } else {
      items.unshift({
        id,
        title: toggle.dataset.productTitle || '',
        url: toggle.dataset.productUrl || '#',
        image: toggle.dataset.productImage || '',
        price: toggle.dataset.productPrice || '',
      });
    }
    save(items);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer?.classList.contains('is-open')) close();
  });

  document.addEventListener('shopify:section:load', render);
  document.addEventListener('heading-slider:load', render);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => window.setTimeout(render, 100));
  }

  const observer = new MutationObserver((mutations) => {
    const needsSync = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches?.('[data-wishlist-toggle], [data-wishlist-count]') ||
            node.querySelector?.('[data-wishlist-toggle], [data-wishlist-count]'))
      )
    );
    if (needsSync) render();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  render();
})();
